import { UTM_PARAMETERS } from "@/constants/utm";

export function getUTMParametersFromQuery(
  params: URLSearchParams,
): Array<[string, string]> {
  const entries: Array<[string, string]> = [];

  for (const key of UTM_PARAMETERS) {
    const value = params.get(key);
    if (value) {
      entries.push([key, value]);
    }
  }

  return entries;
}
